import styled from 'styled-components';
import { colors, typography, layout } from '../../theme';
// import Swiper from 'react-id-swiper';

import { HeadingThree, Text } from '../../elements';

export const Wrapper = styled.div`
  margin-top: ${160 / typography.BASE_FONT_SIZE}rem;
  overflow: hidden;
  position: relative;
  width: 100%;
  display: inline-block;
  padding-top: 3px;
  @media all and (max-width: 1023px) and (min-width: 667px) {
    margin-top: ${70 / typography.BASE_FONT_SIZE}rem;
  }
  @media screen and (max-width: 666px) {
    margin-top: ${80 / typography.BASE_FONT_SIZE}rem;
  }
`;

export const DoubleMargin = styled.div`
  margin-bottom: ${50 / typography.BASE_FONT_SIZE}rem;
  @media screen and (max-width: 666px) {
    margin-bottom: ${40 / typography.BASE_FONT_SIZE}rem;
    margin-top: ${30 / typography.BASE_FONT_SIZE}rem;
  }
`;

export const Blocker = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background: rgba(0, 255, 0, 0.3);
  pointer-events: none;
  display: none;
`;

export const Items = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  float: left;
  // column-count: 2;
  // column-gap: ${80 / typography.BASE_FONT_SIZE}rem;
  ${typography.BODY__SMALL}

  li {
    width: 50%;
    float: left;
    padding-right: ${50 / typography.BASE_FONT_SIZE}rem;

    &:nth-child(2n+3) {
      clear: left;
    }

    &:nth-child(2n+2) {
      padding-left: ${50 / typography.BASE_FONT_SIZE}rem;
      padding-right: 0px;
    }

    @media screen and (max-width: 666px) {
      padding-left: 0px !important;
      padding-right: 0px !important;
      width: 100%;
    }

  }

  @media all and (max-width: 1023px) and (min-width: 667px) {

  }


`;



// WEBPACK FOOTER //
// ./src/components/EditorialList/style.js